import { render, staticRenderFns } from "./DataPagination.vue?vue&type=template&id=76a8e28a"
import script from "./DataPagination.vue?vue&type=script&lang=js"
export * from "./DataPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports